import { urls } from './';

const images = {
    logo: urls.assets + 'images/logo_anbima_home.png',

    close_menu: urls.assets + 'images/close_menu.svg',

    left_arrow_menu: urls.assets + 'images/left-arrow-menu.svg',
    right_arrow_menu: urls.assets + 'images/right-arrow-menu.svg',

    vector_off: urls.assets + 'images/vector_off.png',
    vector_on: urls.assets + 'images/vector_on.png',

    vector_off_mobile: urls.assets + 'images/vector_off_mobile@2x.png',
    vector_on_mobile: urls.assets + 'images/vector_on_mobile@2x.png',

    more_icon: urls.assets + 'images/more_icon.png',

    mensagens_presidencia: urls.assets + 'images/mensagens/presidencia.png',
    mensagens_superintendencia: urls.assets + 'images/mensagens/superintendencia.png',

    quem_somos_perfil: urls.assets + 'images/quem-somos-perfil/first.jpg',
    quem_somos_perfil_rtm: urls.assets + 'images/quem-somos-perfil/rtm-logo.png',
    quem_somos_perfil_galgo: urls.assets + 'images/quem-somos-perfil/galgo-logo.png',
    quem_somos_perfil_icon_rep: urls.assets + 'images/quem-somos-perfil/icone-representar.png',
    quem_somos_perfil_icon_aut: urls.assets + 'images/quem-somos-perfil/icone-autorregular.svg',
    quem_somos_perfil_icon_inf: urls.assets + 'images/quem-somos-perfil/icone-informar.svg',
    quem_somos_perfil_icon_edu: urls.assets + 'images/quem-somos-perfil/icone-educar.svg',
    quem_somos_perfil_arrow: urls.assets + 'images/quem-somos-perfil/arrow-compromissos.png',

    quem_somos_visao_img1: urls.assets + 'images/quem-somos-visao/visao_img1.png',
    quem_somos_visao_img2: urls.assets + 'images/quem-somos-visao/visao_img2.png',
    quem_somos_visao_img3: urls.assets + 'images/quem-somos-visao/visao_img3.png',

    associados_img1: urls.assets + 'images/associados/associados_img1.png',
    associados_img1_hover: urls.assets + 'images/associados/associados_img1_hover.png',

    associados_map_base: urls.assets + 'images/associados/map_0.png',
    associados_map_1: urls.assets + 'images/associados/map_1.png',
    associados_map_2: urls.assets + 'images/associados/map_2.png',
    associados_map_3: urls.assets + 'images/associados/map_3.png',
    associados_map_4: urls.assets + 'images/associados/map_4.png',
    associados_map_5: urls.assets + 'images/associados/map_5.png',

    associados_icon_1: urls.assets + 'images/associados/associados_1.svg',
    associados_icon_2: urls.assets + 'images/associados/associados_2.svg',
    associados_icon_3: urls.assets + 'images/associados/associados_3.svg',
    associados_icon_4: urls.assets + 'images/associados/associados_4.svg',
    associados_icon_5: urls.assets + 'images/associados/associados_5.svg',

    associados_lista: urls.assets + 'images/associados/associados_img2.png',
    associados_lista_hover: urls.assets + 'images/associados/associados_img2_hover.png',

    assembleia_geral_img1: urls.assets + 'images/governanca-corporativa/assembleia/assembleia_img1.png',
    assembleia_geral_img2: urls.assets + 'images/governanca-corporativa/assembleia/assembleia_img2.png',
    assembleia_geral_img3: urls.assets + 'images/governanca-corporativa/assembleia/assembleia_img3.png',

    assembleia_icon_1: urls.assets + 'images/governanca-corporativa/assembleia/assembleia1.svg',
    assembleia_icon_2: urls.assets + 'images/governanca-corporativa/assembleia/assembleia2.svg',
    assembleia_icon_3: urls.assets + 'images/governanca-corporativa/assembleia/assembleia3.svg',

    diretoria_img1: urls.assets + 'images/governanca-corporativa/diretoria/diretoria_img1.png',

    diretoria_icon_1: urls.assets + 'images/governanca-corporativa/diretoria/diretoria1.svg',
    diretoria_icon_2: urls.assets + 'images/governanca-corporativa/diretoria/diretoria2_2.png',
    diretoria_icon_3: urls.assets + 'images/governanca-corporativa/diretoria/diretoria3.svg',
    diretoria_icon_4: urls.assets + 'images/governanca-corporativa/diretoria/diretoria4.svg',

    governanca_vector: urls.assets + 'images/governanca-corporativa/curve_vector.svg',
    person_vector: urls.assets + 'images/governanca-corporativa/person_vector.svg',

    presidente: urls.assets + 'images/governanca-corporativa/diretoria/presidente/01_Carlos-Ambrosio.png',

    vice_presidente1: urls.assets + 'images/governanca-corporativa/diretoria/vice-presidentes/02_Carlos-Andre.png',
    vice_presidente2: urls.assets + 'images/governanca-corporativa/diretoria/vice-presidentes/03_Flavio-Souza.png',
    vice_presidente3: urls.assets + 'images/governanca-corporativa/diretoria/vice-presidentes/04_Jose-Eduardo-Laloni.png',
    vice_presidente4: urls.assets + 'images/governanca-corporativa/diretoria/vice-presidentes/05_Luiz-Sorge.png',
    vice_presidente5: urls.assets + 'images/governanca-corporativa/diretoria/vice-presidentes/06_Miguel-Ferreira.png',
    vice_presidente6: urls.assets + 'images/governanca-corporativa/diretoria/vice-presidentes/07_Pedro-Lorenzini.png',
    vice_presidente7: urls.assets + 'images/governanca-corporativa/diretoria/vice-presidentes/08_Ricardo-Almeida.png',
    vice_presidente8: urls.assets + 'images/governanca-corporativa/diretoria/vice-presidentes/09_Sergio-Cutolo.png',

    diretor1: urls.assets + 'images/governanca-corporativa/diretoria/diretores/01_Adriano-Koelle.png',
    diretor2: urls.assets + 'images/governanca-corporativa/diretoria/diretores/02_Alenir-Romanello.png',
    diretor3: urls.assets + 'images/governanca-corporativa/diretoria/diretores/03_Fernando-Rabello.png',
    diretor4: urls.assets + 'images/governanca-corporativa/diretoria/diretores/04_Jan-Karstens.png',
    diretor5: urls.assets + 'images/governanca-corporativa/diretoria/diretores/05_Julio-Capua.png',
    diretor6: urls.assets + 'images/governanca-corporativa/diretoria/diretores/06_Luiz-Chrysostomo.png',
    diretor7: urls.assets + 'images/governanca-corporativa/diretoria/diretores/07_Luiz-Fernando-Figueiredo.png',
    diretor8: urls.assets + 'images/governanca-corporativa/diretoria/diretores/08_Lywal-Salles.png',
    diretor9: urls.assets + 'images/governanca-corporativa/diretoria/diretores/09_Pedro-Juliano.png',
    diretor10: urls.assets + 'images/governanca-corporativa/diretoria/diretores/10_Pedro-Rudge.png',
    diretor11: urls.assets + 'images/governanca-corporativa/diretoria/diretores/11_Reinaldo-Lacerda.png',
    diretor12: urls.assets + 'images/governanca-corporativa/diretoria/diretores/12_Sasa-Markus.png',
    diretor13: urls.assets + 'images/governanca-corporativa/diretoria/diretores/13_Teodoro-Lima.png',

    conselho_icon_1: urls.assets + 'images/governanca-corporativa/conselho-fiscal/conselho_icon1.svg',
    conselho_icon_2: urls.assets + 'images/governanca-corporativa/conselho-fiscal/conselho_icon2.svg',
    conselho_icon_3: urls.assets + 'images/governanca-corporativa/conselho-fiscal/conselho_icon3.svg',
    conselho_icon_4: urls.assets + 'images/governanca-corporativa/conselho-fiscal/conselho_icon4.svg',

    conselheiro_fiscal1: urls.assets + 'images/governanca-corporativa/conselho-fiscal/01_Arnaldo-Alves-dos-Santos.png',
    conselheiro_fiscal2: urls.assets + 'images/governanca-corporativa/conselho-fiscal/02_Luiz-Tozzato.png',
    conselheiro_fiscal3: urls.assets + 'images/governanca-corporativa/conselho-fiscal/03_Luiz-Guilherme-Mendonca.png',


    conselho_etica_icon_1: urls.assets + 'images/governanca-corporativa/conselho-etica/etica_icon_1.svg',
    conselho_etica_icon_2: urls.assets + 'images/governanca-corporativa/conselho-etica/etica_icon_2.svg',
    conselho_etica_icon_3: urls.assets + 'images/governanca-corporativa/conselho-etica/etica_icon_3.svg',
    conselho_etica_icon_4: urls.assets + 'images/governanca-corporativa/conselho-etica/etica_icon_4.svg',
    conselho_etica_icon_5: urls.assets + 'images/governanca-corporativa/conselho-etica/etica_icon_5.svg',
    conselho_etica_icon_6: urls.assets + 'images/governanca-corporativa/conselho-etica/etica_icon_6.svg',

    conselheiro_etica1: urls.assets + 'images/governanca-corporativa/conselho-etica/01_Valdecyr.png',
    conselheiro_etica2: urls.assets + 'images/governanca-corporativa/conselho-etica/02_Luiz-Maia.png',
    conselheiro_etica3: urls.assets + 'images/governanca-corporativa/conselho-etica/03_Cassio-von-Gal.png',
    conselheiro_etica4: urls.assets + 'images/governanca-corporativa/conselho-etica/04_Luis-Fernando-Affonso.png',
    conselheiro_etica5: urls.assets + 'images/governanca-corporativa/conselho-etica/05_Luiz-Candiota.png',
    conselheiro_etica6: urls.assets + 'images/governanca-corporativa/conselho-etica/06_Ricardo-Dollinger.png',
    conselheiro_etica7: urls.assets + 'images/governanca-corporativa/conselho-etica/07_Silmara-Baccani.png',

    comite_executivo1: urls.assets + 'images/governanca-corporativa/comite-executivo/01_Jose-Carlos-Doherty.png',
    comite_executivo2: urls.assets + 'images/governanca-corporativa/comite-executivo/02_Ana-Leoni.png',
    comite_executivo3: urls.assets + 'images/governanca-corporativa/comite-executivo/03_Francisco-Vidinha.png',
    comite_executivo4: urls.assets + 'images/governanca-corporativa/comite-executivo/04_Guilherme-Benaderet.png',
    comite_executivo5: urls.assets + 'images/governanca-corporativa/comite-executivo/05_Patricia-Herculano.png',
    comite_executivo6: urls.assets + 'images/governanca-corporativa/comite-executivo/06_Eliana-Marino.png',
    comite_executivo7: urls.assets + 'images/governanca-corporativa/comite-executivo/07_Lina.png',
    comite_executivo8: urls.assets + 'images/governanca-corporativa/comite-executivo/08_Marcelo-Billi.png',
    comite_executivo9: urls.assets + 'images/governanca-corporativa/comite-executivo/09_Soraya-Alves-copy.png',
    comite_executivo10: urls.assets + 'images/governanca-corporativa/comite-executivo/10_Thiago-Baptista.png',

    nossos_foruns_img1: urls.assets + 'images/governanca-corporativa/nossos-foruns/nossos_foruns_img1.png',
    nossos_foruns_img1_hover: urls.assets + 'images/governanca-corporativa/nossos-foruns/nossos_foruns_img1_hover2.png',

    nossos_foruns_img2: urls.assets + 'images/governanca-corporativa/nossos-foruns/nossos_foruns_img2.png',

    nossos_foruns_icon_apoio: urls.assets + 'images/governanca-corporativa/nossos-foruns/icone-apoio.svg',
    nossos_foruns_icon_distribuicao: urls.assets + 'images/governanca-corporativa/nossos-foruns/icone-distribuicao.svg',
    nossos_foruns_icon_fundo_investimento: urls.assets + 'images/governanca-corporativa/nossos-foruns/icone-fundo-investimentos.svg',
    nossos_foruns_icon_mercado_de_capitais: urls.assets + 'images/governanca-corporativa/nossos-foruns/icone-mercado-de-capitais.svg',
    nossos_foruns_icon_produtos_servicos: urls.assets + 'images/governanca-corporativa/nossos-foruns/icone-produtos-servicos.svg',
    nossos_foruns_icon_tesouraria: urls.assets + 'images/governanca-corporativa/nossos-foruns/icone-tesouraria.svg',

    pessoas_img_1: urls.assets + 'images/pessoas/pessoas/pessoas_img_1.png',
    pessoas_img_1_hover: urls.assets + 'images/pessoas/pessoas/pessoas_img_1_hover.png',
    vector_organograma: urls.assets + 'images/pessoas/pessoas/vector_organograma2.svg',
    vector_organograma_mobile: urls.assets + 'images/pessoas/pessoas/vector_organograma_mobile.svg',
    pessoas_organograma_mobile: urls.assets + 'images/pessoas/pessoas/organograma_mobile.png',

    qualidade_vida_img1: urls.assets + 'images/pessoas/qualidade-de-vida/qualidade_vida_img1.png',
    qualidade_vida_img1_hover: urls.assets + 'images/pessoas/qualidade-de-vida/qualidade_vida_img1_hover.png',
    qualidade_vida_img2: urls.assets + 'images/pessoas/qualidade-de-vida/qualidade_vida_img2.png',

    engajamento_img1: urls.assets + 'images/pessoas/engajamento/engajamento_img1.png',
    engajamento_img2: urls.assets + 'images/pessoas/engajamento/engajamento_img2.png',
    engajamento_mulher: urls.assets + 'images/pessoas/engajamento/mulher.png',
    engajamento_homem: urls.assets + 'images/pessoas/engajamento/homem.png',

    perfil_mulher: urls.assets + 'images/pessoas/perfil/mulher.png',
    perfil_mulher_hover: urls.assets + 'images/pessoas/perfil/mulher_hover.png',
    perfil_homem: urls.assets + 'images/pessoas/perfil/homem.png',
    perfil_homem_hover: urls.assets + 'images/pessoas/perfil/homem_hover.png',
    perfil_map_base: urls.assets + 'images/pessoas/perfil/map.png',
    perfil_mulher_table: urls.assets + 'images/pessoas/perfil/mulher_table.png',
    perfil_homem_table: urls.assets + 'images/pessoas/perfil/homem_table.png',
    perfil_base_pessoas: urls.assets + 'images/pessoas/perfil/base_pessoas.svg',

    perfil_tempo_grafico_2016: urls.assets + 'images/pessoas/perfil/tempo_grafico_2016.png',
    perfil_tempo_grafico_2017: urls.assets + 'images/pessoas/perfil/tempo_grafico_2017.png',
    perfil_tempo_grafico_2018: urls.assets + 'images/pessoas/perfil/tempo_grafico_2018.png',

    relacionamentos_img1: urls.assets + 'images/estrategia/relacionamentos/relacionamentos_img1.png',
    relacionamentos_img1_hover: urls.assets + 'images/estrategia/relacionamentos/relacionamentos_img1_hover.png',
    relacionamentos_b3: urls.assets + 'images/estrategia/relacionamentos/b3.png',
    relacionamentos_cvm: urls.assets + 'images/estrategia/relacionamentos/cvm.png',
    relacionamentos_empea: urls.assets + 'images/estrategia/relacionamentos/empea.png',

    parceiros_ABRAPP: urls.assets + 'images/estrategia/relacionamentos/parceiros/ABRAPP.png',
    parceiros_ABVCAP: urls.assets + 'images/estrategia/relacionamentos/parceiros/ABVCAP.png',
    parceiros_Ancord: urls.assets + 'images/estrategia/relacionamentos/parceiros/Ancord.png',
    parceiros_CFA: urls.assets + 'images/estrategia/relacionamentos/parceiros/CFA.png',
    parceiros_CNSEG: urls.assets + 'images/estrategia/relacionamentos/parceiros/CNSEG.png',
    parceiros_fenaprevi: urls.assets + 'images/estrategia/relacionamentos/parceiros/fenaprevi.jpeg',
    

    governo_MINAS_ENERGIA: urls.assets + 'images/estrategia/relacionamentos/governo/MINAS_ENERGIA.png',
    governo_BANCO_MUNDIAL: urls.assets + 'images/estrategia/relacionamentos/governo/BANCO_MUNDIAL.png',
    governo_BC: urls.assets + 'images/estrategia/relacionamentos/governo/BC.png',
    governo_BNDES: urls.assets + 'images/estrategia/relacionamentos/governo/BNDES.png',
    governo_LabInovacao: urls.assets + 'images/estrategia/relacionamentos/governo/LabInovacao.png',
    governo_MINISTERIO_FAZENDA: urls.assets + 'images/estrategia/relacionamentos/governo/MINISTERIO_FAZENDA.png',
    governo_MINISTERIO_PLANEJAMENTO: urls.assets + 'images/estrategia/relacionamentos/governo/MINISTERIO_PLANEJAMENTO.png',
    governo_PPI: urls.assets + 'images/estrategia/relacionamentos/governo/PPI.png',
    governo_previc: urls.assets + 'images/estrategia/relacionamentos/governo/previc.png',
    governo_RECEITA_FEDERAL: urls.assets + 'images/estrategia/relacionamentos/governo/RECEITA-FEDERAL.jpg',
    governo_SUSEP: urls.assets + 'images/estrategia/relacionamentos/governo/SUSEP.png',
    governo_tesouro_nacional: urls.assets + 'images/estrategia/relacionamentos/governo/tesouro-nacional.jpg',

    internacionais_FIAFIN: urls.assets + 'images/estrategia/relacionamentos/internacionais/FIAFIN.png',
    internacionais_ICMA: urls.assets + 'images/estrategia/relacionamentos/internacionais/ICMA.png',
    internacionais_IFIE: urls.assets + 'images/estrategia/relacionamentos/internacionais/IFIE.png',
    internacionais_IIFA: urls.assets + 'images/estrategia/relacionamentos/internacionais/IIFA.png',
    internacionais_IOSCO: urls.assets + 'images/estrategia/relacionamentos/internacionais/IOSCO.png',
    internacionais_SMPG: urls.assets + 'images/estrategia/relacionamentos/internacionais/SMPG.png',

    nacionais_ABBC: urls.assets + 'images/estrategia/relacionamentos/nacionais/ABBC.png',
    nacionais_ABBI: urls.assets + 'images/estrategia/relacionamentos/nacionais/ABBI.png',
    nacionais_Abrasca: urls.assets + 'images/estrategia/relacionamentos/nacionais/Abrasca.png',
    nacionais_Apimec: urls.assets + 'images/estrategia/relacionamentos/nacionais/Apimec.png',
    nacionais_CCEC: urls.assets + 'images/estrategia/relacionamentos/nacionais/CCEC.png',
    nacionais_CODIM: urls.assets + 'images/estrategia/relacionamentos/nacionais/CODIM.png',
    nacionais_FEBRABAN: urls.assets + 'images/estrategia/relacionamentos/nacionais/FEBRABAN.png',
    nacionais_FPSB: urls.assets + 'images/estrategia/relacionamentos/nacionais/FPSB.png',

    fazemos_AEF: urls.assets + 'images/estrategia/relacionamentos/fazemos-parte/AEF.png',
    fazemos_CAF: urls.assets + 'images/estrategia/relacionamentos/fazemos-parte/CAF.png',
    fazemos_CNF: urls.assets + 'images/estrategia/relacionamentos/fazemos-parte/CNF.png',
    fazemos_PLANEJAR: urls.assets + 'images/estrategia/relacionamentos/fazemos-parte/PLANEJAR.png',

    academia_CIEE: urls.assets + 'images/estrategia/relacionamentos/academia/CIEE.png',
    academia_IepeCdG: urls.assets + 'images/estrategia/relacionamentos/academia/IepeCdG.png',
    academia_INSPER: urls.assets + 'images/estrategia/relacionamentos/academia/INSPER.png',
    academia_NFC: urls.assets + 'images/estrategia/relacionamentos/academia/NFC.png',

    iniciativas_img1: urls.assets + 'images/nosso-ano/principais-iniciativas/iniciativas_img1.png',
    iniciativas_img1_hover: urls.assets + 'images/nosso-ano/principais-iniciativas/iniciativas_img1_hover.png',
    iniciativas_map1: urls.assets + 'images/nosso-ano/principais-iniciativas/map1.png',
    iniciativas_map1: urls.assets + 'images/nosso-ano/principais-iniciativas/map1.png',
    ico_site: urls.assets + 'images/nosso-ano/principais-iniciativas/ico_site.png',
    selic: urls.assets + 'images/nosso-ano/principais-iniciativas/selic.png',

    nosso_ano_01_setembro1: urls.assets + 'images/nosso-ano/eventos/01_setembro1.png',
    nosso_ano_01_setembro2: urls.assets + 'images/nosso-ano/eventos/01_setembro2.png',
    nosso_ano_01_setembro3: urls.assets + 'images/nosso-ano/eventos/01_setembro3.png',
    nosso_ano_01_setembro4: urls.assets + 'images/nosso-ano/eventos/01_setembro4.png',

    nosso_ano_03_marco1: urls.assets + 'images/nosso-ano/eventos/03_marco1.png',
    nosso_ano_04_abril1: urls.assets + 'images/nosso-ano/eventos/04_abril1.png',
    nosso_ano_06_junho1: urls.assets + 'images/nosso-ano/eventos/06_junho1.png',
    nosso_ano_06_junho2: urls.assets + 'images/nosso-ano/eventos/06_junho2.png',
    nosso_ano_06_junho3: urls.assets + 'images/nosso-ano/eventos/06_junho3.png',
    nosso_ano_06_2_junho1: urls.assets + 'images/nosso-ano/eventos/06_2_junho1.png',
    nosso_ano_08_agosto1: urls.assets + 'images/nosso-ano/eventos/08_agosto1.png',
    nosso_ano_10_outubro1: urls.assets + 'images/nosso-ano/eventos/10_outubro1.png',
    nosso_ano_10_2_outubro1: urls.assets + 'images/nosso-ano/eventos/10_2_outubro1.png',
    nosso_ano_11_novembro1: urls.assets + 'images/nosso-ano/eventos/11_novembro1.png',
    nosso_ano_12_dezembro1: urls.assets + 'images/nosso-ano/eventos/12_dezembro1.png',

    investimento_img1: urls.assets + 'images/nosso-ano/investimentos/investimentos_img1.png',
    investimento_homem: urls.assets + 'images/nosso-ano/investimentos/homem.png',
    investimento_mulher: urls.assets + 'images/nosso-ano/investimentos/mulher.png',
    investimento_base: urls.assets + 'images/nosso-ano/investimentos/base.png',

    icon_relatorios_1: urls.assets + 'images/relatorio/relatorios_1.svg',
    icon_relatorios_2: urls.assets + 'images/relatorio/relatorios_2.svg',
    icon_relatorios_3: urls.assets + 'images/relatorio/relatorios_3.svg',
    icon_relatorios_4: urls.assets + 'images/relatorio/relatorios_4.svg',
    icon_relatorios_5: urls.assets + 'images/relatorio/relatorios_5.svg',
    icon_relatorios_6: urls.assets + 'images/relatorio/relatorios_6.svg',
    icon_relatorios_7: urls.assets + 'images/relatorio/relatorios_7.svg',
    icon_relatorios_8: urls.assets + 'images/relatorio/relatorios_8.svg',

    not_found: urls.assets + 'images/errors/404.png',

    creditos_window: urls.assets + 'images/creditos/window.png',
    creditos_monitor_mobile: urls.assets + 'images/creditos/monitor_mobile.png',
    creditos_user_icons: urls.assets + 'images/creditos/user_icons.png',
    creditos_arrow_down: urls.assets + 'images/creditos/arrow_down.svg',

    gray_layer: urls.assets + 'images/gray_layer.png',
    green_layer: urls.assets + 'images/green_layer.png',
    blue_layer: urls.assets + 'images/blue_layer.png',
    orange_layer: urls.assets + 'images/orange_layer.png'
};

export { images };